import { useContext, useState } from "react";
import styled from "styled-components";
import { Button, Alert } from "antd";
import { useForm } from "react-hook-form";

import { NotificationStateContext } from "context/UI/Notification/NotificationState";
import { apiAxios } from "services/HttpServices";

function AddStaffForm() {
  const [error, setError] = useState("");
  const { handleSubmit, register, errors, control, reset } = useForm();
  const {
    state: notificationState,
    setSuccessMessage,
    clearSuccessMessage,
    setLoading,
    finishLoading,
  } = useContext(NotificationStateContext);

  const onSubmit = async (values) => {
    setError("");
    setLoading("addStaff");
    try {
      await apiAxios.post("/users", values);
      finishLoading("addStaff");
      setSuccessMessage("Added staff succesfull");
      clearSuccessMessage();
      reset();
    } catch (e) {
      finishLoading("addStaff");
      console.log(e.response.data.message);
      setError(e.response.data.message);
    }
  };

  return (
    <StyledContainer errors={errors}>
      {error && (
        <div className="alert">
          <Alert message={error} type="error" showIcon />
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input-container">
          <div className="label-container">
            <label htmlFor="name" className="label">
              Name
            </label>
            {errors.name && <div className="error">{errors.name.message}</div>}
          </div>
          <input
            id="name"
            name="name"
            className={errors.name ? "input-error" : "input"}
            type="text"
            placeholder="Abu Ali"
            ref={register({
              required: "Please insert staff name",
            })}
          />
        </div>

        <div className="input-container">
          <div className="label-container">
            <label htmlFor="email" className="label">
              Email
            </label>
            {errors.email && (
              <div className="error">{errors.email.message}</div>
            )}
          </div>
          <input
            id="email"
            name="email"
            className={errors.email ? "input-error" : "input"}
            type="email"
            placeholder="ali@gmail.com"
            ref={register({
              required: "Please insert staff email",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "Invalid email address",
              },
            })}
          />
        </div>

        <div className="input-container">
          <div className="label-container">
            <label htmlFor="password" className="label">
              Password
            </label>
            {errors.password && (
              <div className="error">{errors.password.message}</div>
            )}
          </div>
          <input
            id="password"
            name="password"
            className={errors.password ? "input-error" : "input"}
            type="password"
            ref={register({
              required: "please insert password",
            })}
          />
        </div>

        <div className="button">
          <Button
            size="medium"
            type="primary"
            htmlType="submit"
            loading={notificationState.loading.addStaff}
          >
            Add Staff
          </Button>
        </div>
      </form>
    </StyledContainer>
  );
}

const StyledContainer = styled.div`
  border-radius: 3px;
  background: ${(props) => props.theme.colors.grey[400]};
  padding: 20px;
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(244, 245, 247, 0.1),
    0 1px 2px 0 rgba(244, 245, 247, 0.06);

  .alert {
    margin-bottom: 15px;
  }

  .button {
    display: flex;
    justify-content: flex-end;
  }

  .input-container {
    padding-bottom: 1.5rem;

    .label-container {
      display: flex;
      justify-content: space-between;

      .label {
        font-weight: 600;
        padding-bottom: 0.25rem;
        display: block;
        font-size: 14px;
      }

      .error {
        color: ${(props) => props.theme.colors.red[700]};
        font-style: italic;
      }
    }

    .input,
    .input-error {
      width: 100%;
      padding: 0.5rem 1rem;
      border-radius: 0.25rem;
      background: ${(props) => props.theme.colors.grey[100]};
      border: 1px solid ${(props) => props.theme.colors.grey[500]};

      ::placeholder {
        color: ${(props) => props.theme.colors.grey[500]};
        opacity: 1; /* Firefox */
      }

      &:focus {
        outline: none !important;
        border: ${(props) => `1px solid
          ${props.theme.colors.primary}`};
      }

      &.input-error,
      .input-error:focus {
        outline: none !important;
        border: ${(props) => `1px solid
          ${props.theme.colors.error.primary}`};
      }
    }
  }
`;

export default AddStaffForm;
